// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      no-data-text="Zone has no gates"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            {{ getEndpointName(props.item.endpoint) }}
          </td>
          <td class="text-xs-left">
            {{ props.item.direction }}
          </td>
          <td class="text-xs-left">
            {{ getAntennaName(props.item.antenna) }}
          </td>
          <td style="width: 1%; padding: 0px; white-space:nowrap;">
            <v-btn title="Edit" icon text v-if="canModify" @click="editItem(props.index)"><v-icon>edit</v-icon></v-btn>
            <v-btn title="Delete" icon text v-if="canModify" @click="deleteItem(props.index)"><v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title class="title">
          Edit Gate
        </v-card-title>
        <v-card-text>
          <v-form v-model="formValid" ref="form">
            <v-autocomplete
              label="Endpoint"
              item-text="name"
              item-value="_id"
              v-bind:items="endpoints"
              v-model="editCert.endpoint"
              required
              :rules="[ruleRequired(editCert.endpoint)]"
              :men-props="'auto'"
            ></v-autocomplete>
            <v-select
             v-model="editCert.direction"
            label="Direction"
            :items="directions">
            </v-select>
            <v-select
             v-model="editCert.antenna"
            label="Antenna"
            :items="antennas">
            </v-select>
          </v-form>
        </v-card-text>
      <v-card-actions>
        <v-btn color="error" text @click.stop="done">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn fab dark class="green" @click.stop="addItem()" id="addButton" v-if="canModify"><v-icon>add</v-icon></v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import {checkPermission} from 'vue-common/components/user'
import {PERMISSIONS} from 'vue-common/components/constants'

export default {
  name: 'zone-gates',

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      items: this.value,
      antennas: [{text: 'All', value: -1}, 0, 1, 2, 3, 4, 5, 6, 7, 8],
      directions: ['NEAR', 'GONE', 'IN', 'OUT'],
      editCert: {},
      endpoints: [],
      formValid: true,
      showDialog: false,
      headers: [
        {
          text: 'Endpoint',
          value: 'endpoint',
          sortable: true
        },
        {
          text: 'Direction',
          value: 'direction',
          sortable: true
        },
        {
          text: 'Antenna',
          value: 'antenna',
          sortable: true
        },
        {
          text: 'Actions',
          value: 'name',
          sortable: false
        }
      ]
    }
  },

  created () {
    ApiRequests.getEndpoints(this.selectedSite._id).then((response) => {
      this.endpoints = response.data
    })
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'endpoints', PERMISSIONS.MODIFY)
    }
  },

  watch: {
    items () {
      this.$emit('input', this.items)
    },

    value (val) {
      if (this.value === null) {
        this.items = []
      } else {
        this.items = this.value
      }
    }
  },

  methods: {
    addItem: function () {
      this.items.push({})
      this.showDialog = true
      this.editCert = this.items[this.items.length - 1]
    },

    deleteItem: function (index) {
      this.items.splice(index, 1)
    },

    done: function () {
      if (this.$refs.form.validate()) {
        this.showDialog = false
      }
    },

    editItem: function (index) {
      this.editCert = this.items[index]
      this.showDialog = true
    },

    getAntennaName: function (num) {
      if (num < 0) {
        return 'All'
      }
      return num
    },

    getEndpointName: function (id) {
      var loc = this.endpoints.filter(e => e._id === id)[0]
      if (loc) {
        return loc.name
      } else {
        return 'n/a'
      }
    },

    ruleRequired: function (value) {
      if (value !== null && value !== '' && value !== [] && value !== undefined && value.id !== '') {
        return true
      } else {
        return 'Please select an value'
      }
    }
  }
}
</script>

<style scoped>
  #addButton {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 20px !important;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/ZoneGates.vue